'use client';

import './ProductDetails.css';

const Block = ({
  className = '',
  style,
}: {
  className?: string;
  style?: React.CSSProperties;
}) => (
  <div
    className={`ui-animate-pulse ui-rounded ui-bg-gray-200 ${className}`}
    style={style}
  />
);

export const ProductDetailsClientSideSkeleton = () => {
  return (
    <div>
      <section className="pdp__top-section ui-py-8 ui-pb-12 ui-bg-gray-100">
        <div className="ui-container !ui-max-w-screen-xl">
          <div className="pdp__backlink ui-mb-6 ui-flex ui-items-center ui-justify-between">
            <Block className="ui-h-4 ui-w-32" />
            <Block className="ui-h-10 ui-w-20" />
          </div>

          <div className="pdp__top-section-grid ui-min-0 ui-grid md:ui-grid-cols-2 lg:ui-grid-cols-5 ui-gap-6 md:ui-gap-12">
            <div className="pdp__top-section-col-1 lg:ui-col-span-2">
              <Block className="ui-h-[25rem] ui-w-full" />
              <ul className="ui-flex ui-flex-wrap ui-gap-0.5 !ui-m-0 !ui-mt-2 ui-p-0 !ui-list-none">
                {Array.from({ length: 5 }).map((_, i) => (
                  // biome-ignore lint/suspicious/noArrayIndexKey: static skeleton
                  <li key={i} className="ui-w-12 ui-h-12">
                    <Block className="ui-aspect-square ui-w-full ui-p-0.5" />
                  </li>
                ))}
              </ul>
            </div>

            <div className="pdp__top-section-col-2 ui-min-w-0 lg:ui-col-span-3 md:ui-mt-2 ui-space-y-3">
              {/* Header */}
              <Block className="ui-h-7 ui-w-3/4" />
              <Block className="ui-h-4 ui-w-1/4" />
              <Block className="ui-h-10 ui-w-1/2" />
              <Block className="ui-h-5 ui-w-1/5" />

              {/* Swatches */}
              <ul className="ui-flex ui-flex-wrap ui-gap-0.5 !ui-m-0 !ui-mt-2 ui-p-0 !ui-list-none">
                {Array.from({ length: 4 }).map((_, i) => (
                  // biome-ignore lint/suspicious/noArrayIndexKey: static skeleton
                  <li key={i} className="ui-w-12 ui-h-12">
                    <Block className="ui-aspect-square ui-w-full" />
                  </li>
                ))}
              </ul>

              {/* Price */}
              <Block className="ui-h-10 ui-w-1/5" />

              {/* CTAs */}
              <div className="pdp__ctas ui-flex ui-gap-2 ui-flex-wrap !ui-mt-8">
                <Block className="ui-h-12 ui-w-28" />
                <Block className="ui-h-12 ui-w-36" />
                <Block className="ui-h-12 ui-w-36" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="pdp__middle-section">
        <div className="ui-container !ui-max-w-screen-xl ui-space-y-8 lg:ui-space-y-12 ui-py-8 md:ui-py-12">
          {/* Specs section */}
          <div className="ui-space-y-4">
            <Block className="ui-h-6 ui-w-40" />
            <div className="ui-space-y-2">
              {Array.from({ length: 6 }).map((_, i) => (
                // biome-ignore lint/suspicious/noArrayIndexKey: static skeleton
                <div key={i} className="ui-flex ui-gap-4">
                  <Block className="ui-h-6 ui-w-1/4" />
                  <Block className="ui-h-6 ui-w-1/3" />
                </div>
              ))}
            </div>
          </div>

          {/* Similar products section */}
          <div className="pdp__similar-products ui-space-y-4">
            <Block className="ui-h-6 ui-w-48" />
            <div className="ui-grid ui-grid-cols-2 md:ui-grid-cols-3 lg:ui-grid-cols-4 ui-gap-4">
              {Array.from({ length: 4 }).map((_, i) => (
                // biome-ignore lint/suspicious/noArrayIndexKey: static skeleton
                <div key={i} className="ui-space-y-2">
                  <Block className="ui-aspect-square ui-w-full" />
                  <Block className="ui-h-4 ui-w-3/4" />
                  <Block className="ui-h-3 ui-w-1/2" />
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="pdp__bottom-section ui-bg-gray-100 ui-py-8 md:ui-py-12">
        <div className="ui-container !ui-max-w-screen-xl">
          <div className="pdp__form ui-max-w-screen-md ui-space-y-4">
            <Block className="ui-h-6 ui-w-40" />
            <Block className="ui-h-10 ui-w-full" />
            <Block className="ui-h-10 ui-w-full" />
            <Block className="ui-h-10 ui-w-full" />
            <Block className="ui-h-10 ui-w-32" />
          </div>
        </div>
      </section>
    </div>
  );
};
